import styles from '../../style.module.scss';
import useStore from '../../store/store';
import {useState} from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import {host} from '../../const/const';
import {phoneLocaleRu} from '../../const/phone-locale-ru';

const InputComponent = (props) => (
    <input
        type={props.type}
        ref={props.ref}
        className={props.className}
        value={props?.value || ''}
        onChange={props.onChange}
        maxLength={16}
    />
);

const CloseIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
            d="M4.08859 4.21569L4.14645 4.14645C4.32001 3.97288 4.58944 3.9536 4.78431 4.08859L4.85355 4.14645L10 9.293L15.1464 4.14645C15.32 3.97288 15.5894 3.9536 15.7843 4.08859L15.8536 4.14645C16.0271 4.32001 16.0464 4.58944 15.9114 4.78431L15.8536 4.85355L10.707 10L15.8536 15.1464C16.0271 15.32 16.0464 15.5894 15.9114 15.7843L15.8536 15.8536C15.68 16.0271 15.4106 16.0464 15.2157 15.9114L15.1464 15.8536L10 10.707L4.85355 15.8536C4.67999 16.0271 4.41056 16.0464 4.21569 15.9114L4.14645 15.8536C3.97288 15.68 3.9536 15.4106 4.08859 15.2157L4.14645 15.1464L9.293 10L4.14645 4.85355C3.97288 4.67999 3.9536 4.41056 4.08859 4.21569L4.14645 4.14645L4.08859 4.21569Z"
            fill="currentColor"
        />
    </svg>
);

const CheckAvailablePopup = ({carId, start, finish, onClose}) => {
    const countryCode = useStore((state) => state.countryCode);
    const userTel = useStore((state) => state.userTel);
    const userTelError = useStore((state) => state.userTelError);
    const setUserTel = useStore((state) => state.setUserTel);
    const setUserTelError = useStore((state) => state.setUserTelError);
    const lang = useStore((state) => state.lang);

    const [view, setView] = useState('actions');
    const [similarLoading, setSimilarLoading] = useState(false);
    const [similarError, setSimilarError] = useState('');
    const [submitLoading, setSubmitLoading] = useState(false);
    const [submitError, setSubmitError] = useState('');
    const [submitSuccess, setSubmitSuccess] = useState(false);

    const t = {
        title: lang === 'en'
            ? 'This car is already booked for the selected dates. We have other options for you.'
            : 'Этот автомобиль уже забронирован на выбранные даты. Но у нас есть другие варианты специально для вас.',
        findSimilar: lang === 'en' ? 'Find a replacement' : 'Подобрать замену',
        managerRequest: lang === 'en' ? 'Leave a request for a manager' : 'Оставить заявку менеджеру',
        loading: lang === 'en' ? 'Loading...' : 'Загрузка...',
        fillField: lang === 'en' ? 'Fill in the field' : 'Заполните поле',
        phoneNumber: lang === 'en' ? 'Phone number' : 'Телефон',
        fillPhoneField: lang === 'en' ? 'Fill in the Phone field' : 'Заполните поле Телефон',
        managerHint: lang === 'en'
            ? 'A manager will contact you within 15 minutes.'
            : 'Менеджер свяжется с вами в течение 15 минут.',
        submit: lang === 'en' ? 'Submit request' : 'Оставить заявку',
        consent: lang === 'en'
            ? 'By clicking "Submit request", I confirm that I have read the terms and agree to the processing of my personal data.'
            : 'При нажатии кнопки «Оставить заявку», я подтверждаю, что ознакомлен с условиями и согласен на обработку моих персональных данных.',
        success: lang === 'en' ? 'Request sent. A manager will contact you shortly.' : 'Заявка отправлена. Менеджер свяжется с вами в ближайшее время.',
        similarError: lang === 'en' ? 'Could not find a replacement. Try again.' : 'Не удалось подобрать замену. Попробуйте ещё раз.',
        close: lang === 'en' ? 'Close' : 'Закрыть',
    };

    const handleSimilar = async () => {
        setSimilarError('');
        setSimilarLoading(true);
        try {
            const response = await fetch(
                `${host}?action=order_similar_car&id=${carId}&start=${encodeURIComponent(start)}&finish=${encodeURIComponent(finish)}`
            ).then((res) => res.json());
            if (response?.ok && response?.url) {
                window.location.href = response.url;
                return;
            }
            setSimilarError(response?.message || t.similarError);
        } catch (e) {
            setSimilarError(t.similarError);
            console.error(e);
        } finally {
            setSimilarLoading(false);
        }
    };

    const handleChangeTel = (value) => {
        if (value && value.length <= 12) {
            setUserTel(value);
        }
        if (!value || (value && value.length <= 11)) {
            setUserTelError(t.fillField);
        } else {
            setUserTelError('');
        }
    };

    const handleManagerSubmit = async () => {
        if (!userTel || userTel.replaceAll(' ', '').length < 12) {
            setUserTelError(t.fillPhoneField);
            const inputElement = document.getElementById('userTel');
            if (inputElement) {
                inputElement.focus();
            }
            return;
        }
        setSubmitError('');
        setSubmitLoading(true);
        try {
            const data = {
                action: 'order_unavailable_manager_lead',
                tel: userTel,
                car: carId,
                start,
                finish,
            };
            const response = await fetch(host, {
                method: 'POST',
                body: new URLSearchParams(data),
            }).then((res) => res.json());
            if (response?.ok) {
                setSubmitSuccess(true);
            } else {
                setSubmitError(response?.message || t.similarError);
            }
        } catch (e) {
            setSubmitError(t.similarError);
            console.error(e);
        } finally {
            setSubmitLoading(false);
        }
    };

    return (
        <div className={styles.unavailableOverlay} role="dialog" aria-modal="true">
            <div className={styles.unavailablePopup}>
                <button
                    type="button"
                    className={styles.unavailableClose}
                    aria-label={t.close}
                    onClick={onClose}
                >
                    <CloseIcon/>
                </button>
                {submitSuccess ? (
                    <p className={`${styles.unavailableTitle} p-size`}>{t.success}</p>
                ) : view === 'actions' ? (
                    <>
                        <p className={`${styles.unavailableTitle} p-size`}>{t.title}</p>
                        <div className={styles.unavailableActions}>
                            <button
                                type="button"
                                className={`${styles.unavailableBtn} ${styles.unavailableBtnPrimary}`}
                                disabled={similarLoading}
                                onClick={handleSimilar}
                            >
                                {similarLoading ? t.loading : t.findSimilar}
                            </button>
                            <button
                                type="button"
                                className={`${styles.unavailableBtn} ${styles.unavailableBtnSecondary}`}
                                disabled={similarLoading}
                                onClick={() => setView('form')}
                            >
                                {t.managerRequest}
                            </button>
                        </div>
                        {!!similarError && (
                            <div className={styles.unavailableError}>{similarError}</div>
                        )}
                    </>
                ) : (
                    <>
                        <p className={`${styles.unavailableTitle} p-size`}>{t.managerRequest}</p>
                        <div className={styles.form}>
                            <div className={styles.row}>
                                <div className={`${styles.label} p-small-size`}>{t.phoneNumber}</div>
                                <PhoneInput
                                    id="userTel"
                                    countryCallingCodeEditable={false}
                                    defaultCountry={countryCode}
                                    className={`${styles.maskTel} ${userTelError !== null && !!userTelError.length ? styles.error : ''}`}
                                    value={userTel || ''}
                                    labels={lang === 'en' ? undefined : phoneLocaleRu}
                                    international={true}
                                    withCountryCallingCode={true}
                                    limitMaxLength={true}
                                    inputComponent={InputComponent}
                                    onChange={(e) => handleChangeTel(e)}
                                />
                            </div>
                        </div>
                        <p className={`${styles.unavailableHint} p-extra-small-size`}>{t.managerHint}</p>
                        <button
                            type="button"
                            className={`${styles.unavailableBtn} ${styles.unavailableBtnPrimary} ${styles.unavailableBtnFull}`}
                            disabled={submitLoading}
                            onClick={handleManagerSubmit}
                        >
                            {submitLoading ? t.loading : t.submit}
                        </button>
                        {!!submitError && (
                            <div className={styles.unavailableError}>{submitError}</div>
                        )}
                        <p className={`${styles.unavailableConsent} p-extra-small-size`}>{t.consent}</p>
                    </>
                )}
            </div>
        </div>
    );
};

export default CheckAvailablePopup;
